import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';

import { ContentProfileListComponent } from './content-profile-list.component';

@NgModule({
  declarations: [ContentProfileListComponent],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    DropdownModule,
    DynamicDialogModule,
    InputTextModule,
    RippleModule,
  ],
  exports: [ContentProfileListComponent],
})
export class ContentProfileListModule {}
